import React from 'react';
import InputText from '../Common/InputText';
import Button from '../Common/Button';

export default class Forms extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isFormValid: false,
            firstName: "Mike",
            lastName: ""
        };

    }

    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ isFormValid: false });
        return false;
    }

    render() {
        return (
            <div className="guide-page">
                <h3 className="guide-title">Forms and Validation</h3>            
                <p>When a form element is valid, it should be highlighted green. When a form element is NOT valid, it should be highlighted red and the required text should be shown beneath it. Most of our common components have this functionality built in.</p>
                <p className="card-text">Forms should be wrapped in a Form tag decorated with noValidate. The onSubmit of the form element should preventDefault and call the save or validation function.</p>    
                <p>Once the form has been validated, the class of the form should be set indicating that is was validated.</p>

                <h4>Example</h4>
                <br />
                <form className={this.state.isFormValid ? "" : "was-validated"} noValidate onSubmit={this.onSubmit}>
                    <div className="form-row">
                        <div className="col-md-4 mb-3">
                            <InputText name="validationServer01" label="First Name" type="text" value={this.state.firstName} placeholder="First Name" isRequire={false} onChange={this.onSubmit} />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-md-4 mb-3">
                            <InputText name="validationServer02" label="Last Name" type="text" value={this.state.lastName} placeholder="Last Name" isRequired={true} errorMessage="This is required" onChange={this.onSubmit} />
                        </div>
                    </div>
                    <Button type="submit" bootstrapClass="primary" text="Submit" />
                </form>


            </div>
        );
    }
}
